import { Route, Routes } from "react-router-dom";
import TelaPermissao from "../../../../Base/Permissao/TelaPermissao";
import NotaConsultaScreen from "./NotaConsultaScreen";
import { PermissoesKey } from "../../../../../Constants/Permissoes";
interface INotaScreenProps {
    consultaScreenProps?:INotaScreenProps;
}
export default function NotaScreen({
    consultaScreenProps
}:INotaScreenProps) {
    return <Routes>
        <Route path="/" index element={<TelaPermissao permissoes={["FinanceiroTituloNotaListar"]}><NotaConsultaScreen {...(consultaScreenProps ?? {})} /></TelaPermissao>}></Route>
    </Routes>
}